import { ModulesMap, ModulesConfigMap } from '../modulesMaps'

export default {
	[ModulesConfigMap[ModulesMap.REPORTS_FINANCE_BY_WORK_TYPE].GET_REPORTS_FINANCE_BY_WORK_TYPE]: {
		url: '/company/:companyId/reports/finance/by_work_types/',
	},
}
